function delay(timeout: number) {
  const promise = new Promise<string>((resolve) => {
    setTimeout(() => {
      resolve(`delay ${timeout} sec --> success`)
    }, timeout * 1000)
  })
  return promise
}

export default delay